import logo from "./logo.svg";
import "./App.css";
import AnimatedNumbers from "react-animated-numbers";
import { useState, useRef, useEffect } from "react";

function App() {
  const [age, setAge] = useState("- -");
  const [month, setMonth] = useState("- -");
  const [day, setDay] = useState("- -");
  const [dayErr, setDayErr] = useState();
  const [monErr, setMonErr] = useState();
  const [yearErr, setYearErr] = useState();
  const ageRef = useRef();
  const monthRef = useRef();
  const dayRef = useRef();
  const year = new Date().getFullYear();
  
  const handleAdd = () => {
    const ageInput = parseInt(ageRef.current.value, 10);
    const monthInput = parseInt(monthRef.current.value, 10);
    const dayInput = parseInt(dayRef.current.value, 10);
    const nowMonth = new Date().getMonth() + 1;
    const nowDay = new Date().getDate();
    const Year = new Date().getFullYear();
    let age = Year - ageInput;
    let month = nowMonth - monthInput;
    let day = nowDay - dayInput;
  
    const adjustDate = (value, unit) => {
      if (value < 0) {
        switch (unit) {
          case 'month':
            return 12 + value;
          case 'day':
            return new Date(Year, nowMonth, 0).getDate() + value;
          default:
            return value;
        }
      }
      return value;
    };
  
    day = adjustDate(day, 'day');
    month = adjustDate(month, 'month');
  
    setAge((ageInput < 1900 || ageInput > Year) ? "--" : age);
    setMonth((monthInput > 12 || monthInput <= 0) ? "--" : month);
    setDay((dayInput > 31 || dayInput <= 0) ? "--" : day);
  };
  
  const handleDayErr = (e) => {
    setDayErr(e.target.value);
  };
  
  const handleMonErr = (e) => {
    setMonErr(e.target.value);
  };
  
  const handleYearErr = (e) => {
    setYearErr(e.target.value);
  };
  
  const isValidDay = dayErr >= 1 && dayErr <= 31;
  const isValidMon = monErr >= 1 && monErr <= 12;
  const isValidYear = yearErr >= 1900 && yearErr <= year;
  

  return (
    <div className="App">
      <div className="card">
        <div className="top">
          <div>
            <label
              style={{
                color: dayErr < 1 || dayErr > 31 ? "hsl(0, 100%, 67%)" : "",
              }}
            >
              day
            </label>
            <input
              type="number"
              style={{
                border:
                  dayErr < 1 || dayErr > 31
                    ? "hsl(0, 100%, 67%) 1px solid"
                    : "",
              }}
              ref={dayRef}
              placeholder="DD"
              onChange={handleDayErr}
              value={dayErr}
            />
            {!isValidDay && <p className="err">Must be a valid day</p>}
          </div>
          <div>
            <label
              style={{
                color: monErr < 1 || monErr > 12 ? "hsl(0, 100%, 67%)" : "",
              }}
            >
              month
            </label>
            <input
              type="number"
              style={{
                border:
                  monErr < 1 || monErr > 12
                    ? "hsl(0, 100%, 67%) 1px solid"
                    : "",
              }}
              ref={monthRef}
              placeholder="MM"
              onChange={handleMonErr}
              value={monErr}
            />
            {!isValidMon && <p className="err">Must be a valid month</p>}
          </div>
          <div>
            <label
              style={{
                color:
                  yearErr < 1900 || yearErr > year ? "hsl(0, 100%, 67%)" : "",
              }}
            >
              year
            </label>
            <input
              type="number"
              style={{
                border:
                  yearErr < 1900 || yearErr > year
                    ? "hsl(0, 100%, 67%) 1px solid"
                    : "",
              }}
              ref={ageRef}
              placeholder="YYYY"
              onChange={handleYearErr}
              value={yearErr}
            />
            {!isValidYear && <p className="err">Must be a valid year</p>}
          </div>
        </div>
        <button className="submit" onClick={handleAdd}>
          <img src="icon-arrow.svg" alt="" />
        </button>
        <div className="bottom">
          <h1>
            <span>{age == 0 ? "- -" : age}</span> years
          </h1>
          <h1>
            <span>{month == 0 ? "- -" : month}</span> months
          </h1>
          <h1>
            <span>{day == 0 ? "- -" : day}</span> days
          </h1>
        </div>
      </div>
    </div>
  );
}

export default App;
